import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import * as genericHelper from 'src/app-lib/helpers/genericHelper';
import { Placeholder } from './../loading-state/placeholder';

export class ContentVideoDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    displayContentCategory() {
        return (
          this.props.contentCategory &&
              <div className="content-video-detail__content-category" title={i18n.t(`categories.${this.props.contentCategory}`)}>
              {i18n.t(`categories.${this.props.contentCategory}`)}
              </div>
        );
    }

    displayContentTimeline() {
        return (
            <div className="content-video-detail__timeline">
            {genericHelper.timeSinceToday(this.props.contentPublishDate)}
            </div>
        );
    }

    displayContentTitle() {
        return (
            <div className="content-video-detail__content-title" title={this.props.contentTitle}>{this.props.contentTitle}</div>
        );
    }


    render() {
        const { isFetching } = this.props;
        return (
            <div className="content-video-detail">
                <div className="content-video-detail__sub-detail">
                {isFetching ? <Placeholder height={'12px'} width={'50%'} borderRadius={'3px'} margin={'5px 0px'} float={'left'} /> : this.displayContentCategory()}
                {isFetching ? <Placeholder height={'12px'} width={'30%'} borderRadius={'3px'} margin={'5px 0px 5px 30px'} float={'left'} /> : this.displayContentTimeline()}
                </div>
                {isFetching ?
                    <div>
                        <Placeholder height={'12px'} width={'83%'} borderRadius={'3px'} margin={'15px 15px 0px'} float={'left'} />
                        <Placeholder height={'12px'} width={'50%'} borderRadius={'3px'} margin={'10px 15px 15px'} float={'left'} />
                    </div> : this.displayContentTitle()}
            </div>
      );
    }
}

ContentVideoDetail.propTypes = {
    contentCategory: PropTypes.string,
    contentTitle: PropTypes.string.isRequired,
    contentPublishDate: PropTypes.string.isRequired,
    numOfViews: PropTypes.string,
    isFetching: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/content/content-video-detail.js